export const SITE_URL = 'https://mathosconsult.com'
export const SITE_NAME = 'Mathos Consult'
export const OG_IMAGE = `${SITE_URL}/og-image.png`

export const ORG_SCHEMA = {
  '@type': 'ProfessionalService',
  '@id': `${SITE_URL}/#organization`,
  name: SITE_NAME,
  url: `${SITE_URL}/`,
  description:
    'A service design practice led by Alexander Miller — helping founders and leadership teams design products, services and operations that work for the people who use them.',
  email: 'hello@mathosconsult.com',
  founder: { '@id': `${SITE_URL}/#alexander` },
  sameAs: ['https://linkedin.com/company/mathosconsult'],
  areaServed: 'Worldwide',
}

export const PERSON_SCHEMA = {
  '@type': 'Person',
  '@id': `${SITE_URL}/#alexander`,
  name: 'Alexander Miller',
  jobTitle: 'Service Designer',
  description:
    '30 years across fintech, payments, healthcare, government and enterprise technology. Combines analytical rigour (Six Sigma), human-centred design (UX/service design) and business thinking (D.MBA).',
  worksFor: { '@id': `${SITE_URL}/#organization` },
  url: `${SITE_URL}/about`,
  sameAs: ['https://www.linkedin.com/in/possibilities/'],
}

export function withContext(schemaOrSchemas) {
  if (Array.isArray(schemaOrSchemas)) {
    return {
      '@context': 'https://schema.org',
      '@graph': schemaOrSchemas,
    }
  }
  return { '@context': 'https://schema.org', ...schemaOrSchemas }
}

const HOME_DESC =
  'Mathos Consult is a service design practice led by Alexander Miller. We help founders and leadership teams design products, services and operations that work for the people who use them. 30 years across fintech, payments, healthcare and government.'
const ABOUT_DESC =
  'Alexander Miller — 30 years building things that work, with people trying to build something genuinely better. Fintech, payments, NHS, government, enterprise technology.'
const SERVICES_DESC =
  'Service design, operational design, fractional COO. I help you design the whole experience — not just the product — and build operations that support it.'
const CONTACT_DESC =
  'Book a discovery call with Alexander Miller at Mathos Consult. Service design, operational design, fractional COO for founders and leadership teams.'
const BLOG_DESC =
  'Articles on service design, products, services and operations — from Alexander Miller at Mathos Consult.'

const SERVICES_CATALOG = {
  '@type': 'OfferCatalog',
  '@id': `${SITE_URL}/services#catalog`,
  name: 'Services',
  provider: { '@id': `${SITE_URL}/#organization` },
  itemListElement: [
    {
      '@type': 'Offer',
      itemOffered: {
        '@type': 'Service',
        name: 'Discovery and framing',
        description:
          'Getting the question right before you build anything — clarity on the actual problem, a validated direction.',
      },
    },
    {
      '@type': 'Offer',
      itemOffered: {
        '@type': 'Service',
        name: 'Service and product design',
        description:
          'Human-centred research, journey mapping, service blueprinting and prototyping — designing the full service, not just the screen.',
      },
    },
    {
      '@type': 'Offer',
      itemOffered: {
        '@type': 'Service',
        name: 'Operational design',
        description:
          'Designing the processes, systems and data behind the service so it works at scale.',
      },
    },
    {
      '@type': 'Offer',
      itemOffered: {
        '@type': 'Service',
        name: 'Fractional partner',
        description:
          'Ongoing involvement as a fractional design/operations partner to founders and leadership teams.',
      },
    },
  ],
}

const CONTACT_PAGE_SCHEMA = {
  '@type': 'ContactPage',
  '@id': `${SITE_URL}/contact#contact`,
  name: 'Contact Mathos Consult',
  url: `${SITE_URL}/contact`,
  description: CONTACT_DESC,
  about: { '@id': `${SITE_URL}/#organization` },
}

const BLOG_SCHEMA = {
  '@type': 'Blog',
  '@id': `${SITE_URL}/blog#blog`,
  name: 'Mathos Consult Blog',
  url: `${SITE_URL}/blog`,
  description: BLOG_DESC,
  publisher: { '@id': `${SITE_URL}/#organization` },
}

export const ROUTE_META = {
  '/': {
    title: 'Mathos Consult — Service Design Practice | Alexander Miller',
    description: HOME_DESC,
    jsonLd: withContext([ORG_SCHEMA, PERSON_SCHEMA]),
  },
  '/about': {
    title: 'About — Mathos Consult',
    description: ABOUT_DESC,
    jsonLd: withContext([PERSON_SCHEMA, ORG_SCHEMA]),
  },
  '/services': {
    title: 'Services — Mathos Consult',
    description: SERVICES_DESC,
    jsonLd: withContext([SERVICES_CATALOG, ORG_SCHEMA, PERSON_SCHEMA]),
  },
  '/contact': {
    title: 'Contact — Mathos Consult',
    description: CONTACT_DESC,
    jsonLd: withContext([CONTACT_PAGE_SCHEMA, ORG_SCHEMA, PERSON_SCHEMA]),
  },
  '/blog': {
    title: 'Blog — Mathos Consult',
    description: BLOG_DESC,
    jsonLd: withContext([BLOG_SCHEMA, ORG_SCHEMA]),
  },
}
